import styled from 'styled-components'
import { P } from '@sellpy/design-system-react-web'
import { useTranslation } from 'react-i18next'
import { getRegion } from '../../../../common/region/region.js'
import { RadioButtonWrapper, StyledInput, StyledLabel } from './sharedComponents'

const KlarnaIcon = styled.img`
  margin-left: auto;
  padding-right: 8px;
  max-height: 24px;
  object-fit: contain;
`

const KlarnaSubText = styled(P)`
  color: ${({ theme }) => theme.colour.text.static.nr200};
  padding: 8px;
`

const getKlarnaLocalizedSubHeadline = (t, selectedKlarnaOption) => {
  const region = getRegion()
  return t(`klarnaPaymentOption.${selectedKlarnaOption}.subHeadline.${region}`)
}

export const KlarnaRadioButton = ({
  component,
  isSelected,
  hideUnselected,
  disabled,
  erroneous,
  paymentRefs,
  onSelect
}) => {
  const { t } = useTranslation('checkout')
  const paymentType = component.identifier

  return (
    <RadioButtonWrapper
      disabled={disabled}
      hidden={hideUnselected && !isSelected}
      className={isSelected ? 'selected_payment_option' : ''}
    >
      <span style={{ display: 'flex', alignItems: 'center' }}>
        <StyledInput
          hideButton={hideUnselected}
          checked={isSelected}
          onChange={onSelect}
          value={paymentType}
          disabled={disabled}
          erroneous={erroneous}
        />
        <StyledLabel design='body1' noMargin>
          {component.name}
        </StyledLabel>
        <KlarnaIcon src={component.asset_urls.standard} alt={component.name} />
      </span>
      <div
        style={{ display: isSelected ? 'block' : 'none' }}
        ref={paymentRefs[paymentType]}
        id={paymentType}
      >
        <P design='body3' style={{ padding: '0 8px' }}>
          {isSelected && getKlarnaLocalizedSubHeadline(t, paymentType)}
        </P>
        <KlarnaSubText design='body5'>{t('klarnaPaymentOption.common.subText')}</KlarnaSubText>
      </div>
    </RadioButtonWrapper>
  )
}
